import graphql__bb814c776bc375814bf5 from "./__generated__/UrlRedirectionsManagerQuery.graphql.js";import { graphql, useLazyLoadQuery } from "react-relay";

import { useLocalizedLocationChangeEffect } from "../Utils/localizedLocation";
import { useNavigateTo } from "../Routes/RoutesContext";

export const useUrlRedirectionsManager = () => {
  const { urlRedirections } = useLazyLoadQuery(UrlRedirectionsManagerQuery);

  const urlRedirectionsMap = urlRedirections.reduce(
    (redirections, { source, target }) => ({
      ...redirections,
      [source]: target
    }),
    {}
  );

  const navigateTo = useNavigateTo();

  useLocalizedLocationChangeEffect(
    ({ pathname }) => {
      // Find an existing url redirection in the cached redirections dictionary
      const redirectionTarget = urlRedirectionsMap[pathname];

      if (!redirectionTarget) return;
      // If a redirection was found, actually redirect the user to it, replacing the
      // history entry to mask the redirected URL from the history and allow the user using
      // the back button of his brower.
      navigateTo(redirectionTarget, {}, { replace: true });
    },
    [navigateTo, urlRedirectionsMap]
  );
};

const UrlRedirectionsManagerQuery = graphql__bb814c776bc375814bf5;
